var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurnRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.58374C18.0005 7.32715 17.9029 7.0704 17.7071 6.87462L11.1254 0.292893C10.7349 -0.0976313 10.1017 -0.0976309 9.71117 0.292893C9.32064 0.683418 9.32064 1.31658 9.71117 1.70711L14.5898 6.58576H1.86979C1.3175 6.58576 0.868803 7.03347 0.868803 7.58576L0.868801 21.5858C0.868801 22.138 1.31652 22.5858 1.8688 22.5858C2.42109 22.5858 2.8688 22.138 2.8688 21.5858L2.8688 8.58576H14.5858L9.71117 13.4604C9.32064 13.8509 9.32064 14.4841 9.71117 14.8746C10.1017 15.2651 10.7349 15.2651 11.1254 14.8746L17.7071 8.29286C17.9029 8.09709 18.0005 7.84034 18 7.58374Z",
    fill: "#1F202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnRight);
export default __webpack_public_path__ + "static/media/turnRight.7fc874dce8cdfe737059bfbcc3974ff3.svg";
export { ForwardRef as ReactComponent };